import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import MainPhoto from '@pages/home/cats/MainPhoto';
import { CollarContent } from '@pages/home/cats/CollarContent';
import { AdvantagesProbe } from '@pages/home/cats/AdvantagesProbe';
import { TextBoxProbe } from '@pages/home/cats/TextBoxProbe';
import { Veterinary } from '@pages/home/cats/Veterinary';
import SocialMedia from '@components/social-media/SocialMedia';
import { Infobox } from '@pages/home/cats/Infobox';
import { InfoboxProbe } from '@pages/home/cats/InfoboxProbe';



const Cats = () => {
	const { t } = useTranslation('web');

	const collarRef = useRef<HTMLDivElement>(null);
	const probeRef = useRef<HTMLDivElement>(null);

	
	const scrollToCollar = useCallback(() => {
		collarRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ collarRef ]);

	
	const scrollToProbe = useCallback(() => {
		probeRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ probeRef ]);

	
	return (
		<div className='home-content cats-page'>
			
			<MainPhoto scrollToCollar={scrollToCollar} scrollToProbe={scrollToProbe}/>

			<Infobox />

			<CollarContent />

			<div className='order-button-box'>
				<Link to={NavigateRoutes.catOrder} className='app-main-button disable-selection'>
					{t('shared.orderLongUpper')}
				</Link>
			</div>


			<InfoboxProbe />

			<AdvantagesProbe />

			<TextBoxProbe />

			<Veterinary />

			<div className='order-button-box'>
				<Link to={NavigateRoutes.partners} className='app-main-button disable-selection'>
					{t('shared.orderLongUpper')}
				</Link>
			</div>

			<SocialMedia />

		</div>
	);
};

export default Cats;